module.exports = __webpack_public_path__ + "img/s2P12.39ebbd34.png";